var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#2CAAE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35896 6.97007C4.24529 6.85548 4.24567 6.67055 4.3598 6.55641L6.43693 4.47928C6.56356 4.35265 6.76886 4.35265 6.89549 4.47928L8.97262 6.55641C9.08676 6.67055 9.08713 6.85548 8.97346 6.97007C8.85913 7.08533 8.67291 7.0857 8.55812 6.97091L6.95788 5.37067L6.95788 13.875C6.95788 14.0361 6.82729 14.1667 6.66621 14.1667C6.50513 14.1667 6.37454 14.0361 6.37454 13.875L6.37454 5.37067L4.7743 6.97091C4.65951 7.0857 4.47329 7.08533 4.35896 6.97007ZM9.02647 12.4436C8.91233 12.3295 8.91196 12.1445 9.02563 12.0299C9.13995 11.9147 9.32618 11.9143 9.44097 12.0291L11.0412 13.6293L11.0412 5.125C11.0412 4.96392 11.1718 4.83333 11.3329 4.83333C11.494 4.83333 11.6245 4.96392 11.6245 5.125L11.6245 13.6293L13.2248 12.0291C13.3396 11.9143 13.5258 11.9147 13.6401 12.0299C13.7538 12.1445 13.7534 12.3295 13.6393 12.4436L11.5622 14.5207C11.4355 14.6473 11.2302 14.6473 11.1036 14.5207L9.02647 12.4436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.21d6bec55f5365c1afff02523bcc4262.svg";
export { ForwardRef as ReactComponent };